import { fetchRemoteTheme, getCurrentTheme, type Theme } from '@eduzz/shared';

import { fallbackTheme } from './fallbackTheme';

export const fetchTheme = async (): Promise<NonNullable<Theme['antd']> | undefined> => {
  const remoteTheme = await fetchRemoteTheme();

  if (!remoteTheme || !remoteTheme.themes['default'].antd) {
    return fallbackTheme;
  }

  const currentTheme = getCurrentTheme(remoteTheme);

  if (!remoteTheme.themes[currentTheme].antd) {
    return remoteTheme.themes['default'].antd;
  }

  return remoteTheme.themes[currentTheme].antd;
};
